module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/flower-3-e1c6d60ae450048627f5c57eeab791e1.svg";